"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.56,17l-.08-.06c.09-.23.18-.45.28-.68a3.33,3.33,0,0,0,.07-.84,1.47,1.47,0,0,0-.3-.6l-.43-.29L14,13.9c-.68,0-.68,0-.81,0l-.09.19c0,.2,0,.4,0,.61.2.74.4,1.49.59,2.25l-1.74,0c0-.21.11-.42.17-.64v-.6c-.43-1.28-.85-2.55-1.29-3.84a.55.55,0,0,1,0-.16c-.35,0-.7,0-1.07-.07q0-.79,0-1.59c-.3-.38-.3-.38-.41-.46A8.29,8.29,0,0,0,8,9.47s0,0,0-.06a4.78,4.78,0,0,1,.42-.5.34.34,0,0,1,0-.14.67.67,0,0,1-.14-.11c-.3,0-.62,0-.94-.07s-.49-.09-.73-.15A3.1,3.1,0,0,1,5.78,8a4.09,4.09,0,0,1-.51-.77.49.49,0,0,1,0-.11c.11.12.21.24.32.38L6,7.75c.17,0,.35.09.53.16h.65s0,0,0-.07a3.78,3.78,0,0,1-.6-.75c-.06-.14-.14-.29-.22-.44a2.53,2.53,0,0,0-.07-.38c0-.19,0-.38,0-.58l.16-.38c.09-.15.19-.3.3-.46l.35-.3A8.59,8.59,0,0,0,8.76,3.49V3.23l-.17-.14h-.2l-.27.17c0-.11,0-.18,0-.3A.32.32,0,0,0,8,2.82a2.11,2.11,0,0,1-.3-.07c0-.13,0-.13,0-.16h.75A3.57,3.57,0,0,1,9,2.75a1.08,1.08,0,0,1,.33.39c0,.06,0,.12.06.2l0,.27A1.18,1.18,0,0,1,9,4,16.67,16.67,0,0,0,7.65,5.08c-.08.12-.15.25-.23.38v.46c0,.09.09.18.15.27a1.16,1.16,0,0,0,.44.2l.81,0c.29-.09.57-.2.86-.31H10l.42.31c.15,0,.15,0,3.29.09a12.59,12.59,0,0,1-.06,1.94.55.55,0,0,0,0,.18,1.11,1.11,0,0,0,.18-.45,14.66,14.66,0,0,1,1.61,0,5.53,5.53,0,0,1,1,.23l.68.3L17.5,9l.61.74a4.36,4.36,0,0,1,.28.68c.05.2.1.4.16.61s0,.64,0,1c-.08.61-.08.61-.38,2.08v1a.2.2,0,0,1-.2,0C18,15,18,15,18,12.9l-.11,0c-.1,4.05-.1,4.05-.15,4.11Z",
    style: {
      fill: '#fff',
      fillRule: 'evenodd'
    }
  }));
};

exports["default"] = _default;